import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  balance: {
    smsBalanceCount: "0",
    mainBalanceAmount: "0",
    rcsBalanceCount: "0",
    waBalanceCount: "0",
    smsBalanceList: [],
    mainBalanceAmountList: [],
    rcsBalanceCountList: [],
    waBalanceCountList: [],
    partnerBalance: "0",
    partnerBalanceList: [],
    partnerUnclearBalance: "0",
  },
  customerSummary: [],
};

const balanceSlice = createSlice({
  name: "balance",
  initialState,
  reducers: {
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    setCustomerSummaryData: (state, action) => {
      state.customerSummary = action.payload;
    },
  },
});

export const { setBalance, setCustomerSummaryData } = balanceSlice.actions;

export default balanceSlice.reducer;
